import { render, staticRenderFns } from "./CotPuaViewComponent.vue?vue&type=template&id=07f1211d"
import script from "./CotPuaViewComponent.vue?vue&type=script&lang=js"
export * from "./CotPuaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports